module.exports = __webpack_public_path__ + "img/astral-txt_9.074a7a34.svg";